/**
 * Phase 349 — Global Email Templates management page.
 *
 * Templates are now a shared catalogue across every building. This page hosts
 * the editor experience previously embedded inside each building. Sending is
 * handled per-building from the building's "Emails" tab; here we focus on
 * authoring & curating the template library.
 */
import React from 'react';
import Layout from '../components/Layout';
import EmailTemplatesPanel from '../components/EmailTemplatesPanel';
import { ArrowLeft, Envelope } from '@phosphor-icons/react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

export default function EmailTemplatesGlobal() {
  const { t } = useLanguage();
  const navigate = useNavigate();

  return (
    <Layout>
      <div className="max-w-7xl mx-auto px-4 py-6" data-testid="email-templates-global-page">
        <button
          onClick={() => navigate('/building-settings')}
          className="flex items-center gap-1.5 text-sm text-zinc-500 hover:text-zinc-900 mb-4"
          data-testid="email-templates-global-back"
        >
          <ArrowLeft size={14} />
          <span className="font-semibold">{t('settings') || 'Settings'}</span>
        </button>
        <div className="flex items-center gap-2 mb-4">
          <Envelope size={20} weight="fill" className="text-zinc-700" />
          <div>
            <h1 className="text-xl font-bold" style={{ fontFamily: 'var(--font-heading)' }}>
              {t('emailTemplates') || 'Email Templates'}
            </h1>
            <p className="text-xs text-zinc-500">
              {t('emailTemplatesGlobalHint') ||
                'Templates are shared across every building. Select which one to use from each building\'s Emails tab.'}
            </p>
          </div>
        </div>
        {/* Phase 349 — Reuse the existing panel in "manage-only" mode. The
            panel still ships the placeholder/category chip pickers and the
            full editor; the building-scoped placeholders render with sample
            values when no building context is present. */}
        <EmailTemplatesPanel buildingId="" buildingName="" embedded manageOnly />
      </div>
    </Layout>
  );
}
